import { render, staticRenderFns } from "./CampaignLinkBtn.vue?vue&type=template&id=edce4e6e&scoped=true"
import script from "./CampaignLinkBtn.vue?vue&type=script&lang=js"
export * from "./CampaignLinkBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edce4e6e",
  null
  
)

export default component.exports